var _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_6221_3484)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6477 12.8451C15.7992 12.4433 16.8844 11.7578 17.7138 11.0134L17.7144 11.0147C17.7467 10.9845 17.7667 10.9434 17.7704 10.8994C17.7742 10.8555 17.7614 10.8117 17.7347 10.7765C17.708 10.7413 17.6691 10.7172 17.6256 10.7088C17.5821 10.7004 17.537 10.7084 17.4991 10.7312C16.6671 11.2286 15.7489 11.6224 14.8077 11.8627C14.8358 11.5048 14.8299 11.1445 14.7836 10.7864C14.6772 9.99101 14.4071 9.1963 13.8455 8.59101C13.2234 7.90292 12.2022 7.64575 11.3208 7.92111C10.2618 8.23599 9.37904 9.19002 9.34505 10.3285C9.30223 11.8276 10.6987 13.0494 12.1197 13.1868C12.2855 13.2049 12.4527 13.2138 12.6208 13.214C12.3588 13.7866 12.0188 14.3337 11.655 14.8402C10.5377 12.9972 8.86284 11.4878 6.87195 10.6622C6.40828 10.466 5.92756 10.3125 5.43581 10.2036C5.26834 10.1691 5.10905 10.1384 4.93213 10.119C4.88917 10.1149 4.84617 10.1263 4.81091 10.1511C4.77565 10.1759 4.75046 10.2124 4.73988 10.2541C4.72931 10.2957 4.73406 10.3398 4.75327 10.3783C4.77247 10.4168 4.80488 10.4472 4.84461 10.464C5.95614 11.0136 6.97558 11.7313 7.86673 12.5916C9.02156 13.7026 9.93137 15.0411 10.5381 16.5218C10.8057 17.1598 11.645 17.3931 12.2066 16.9829C12.2928 16.9193 12.3716 16.8463 12.4415 16.7652C12.945 16.2194 13.3882 15.6214 13.7636 14.9813C14.1472 14.3273 14.4631 13.6008 14.6477 12.8451ZM12.1561 15.7669L12.1562 15.7673L12.1707 15.7968C12.1661 15.7867 12.1612 15.7767 12.1561 15.7669ZM13.0133 12.0895C13.1012 11.7139 13.1449 11.332 13.1309 10.9476C13.0937 10.2576 12.828 9.28285 12.0077 9.2678C11.3012 9.25965 10.6515 9.92703 10.8536 10.6358C11.1527 11.6702 12.0461 12.0475 13.0133 12.0895Z",
    fill: "url(#paint1_linear_6221_3484)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2597 10.3096C18.3321 10.6471 18.4435 10.861 18.769 10.8177C19.0485 10.7807 19.279 10.5003 19.279 10.2199C19.279 9.93957 19.0473 9.7583 18.769 9.8022C18.4158 9.85803 18.2005 10.0355 18.2597 10.3096Z",
    fill: "url(#paint2_linear_6221_3484)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6221_3484",
    x1: 0,
    y1: 0.5,
    x2: 24,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5F1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6221_3484",
    x1: 4.73437,
    y1: 7.8125,
    x2: 19.2656,
    y2: 17.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236D66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6221_3484",
    x1: 4.73437,
    y1: 7.8125,
    x2: 19.2656,
    y2: 17.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#236D66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualToken);
export default __webpack_public_path__ + "static/media/virtual-token.ec7bec2d59306a4f41fa057b4a7c95d6.svg";
export { ForwardRef as ReactComponent };